import { Container } from 'pixi.js';
import { getLocalizedValue } from '@softgames/localization';
import { WinStreakLoseProgressIconLayout } from '../../../../../../layouts/popups/failFlow/WinStreakLoseProgressIconLayout';

export interface WinStreakLoseIconConfig {
  level: number;
  currentSteps: number;
  totalSteps: number;
}

export class WinStreakLoseProgressIconView extends Container {
  public readonly layout = new WinStreakLoseProgressIconLayout();

  constructor(config: WinStreakLoseIconConfig) {
    super();

    const { 
      root,
      levelText,
      progressBarFill,
      progressText,
    } = this.layout;

    root.props({
      parent: this,
    });

    levelText.text = getLocalizedValue(config.level);
    progressText.text = `${getLocalizedValue(config.currentSteps)}/${getLocalizedValue(config.totalSteps)}`;
  
    progressBarFill.width *= (config.currentSteps / config.totalSteps);
  }
}
